import { useFormik } from "formik";
import React, { useState } from "react";
import { useToasts } from "react-toast-notifications";
import * as Yup from "yup";

import { Box, BoxHeading } from "../../../components/Box";
import { ButtonCheck } from "../../../components/Form/ButtonCheck";
import { LayoutForm } from "../../../components/Form/LayoutForm";
import { Textarea } from "../../../components/Form/Textarea";
import { Button } from "../../../components/ui/button";
import { RequestUpdateClient } from "../../../hook/queries/useRequestUpdateClient";
import api from "../../../service/api";
import { queryClient } from "../../../service/queryClient";

type FormDataProps = {
  status: string;
  reason: string;
};

interface BoxActionProvider {
  onRefresh: () => void;
  requestUpdateClient: RequestUpdateClient;
  isManager?: boolean;
  isProvider?: boolean;
}

const STATUS_CANCEL = "0";
const STATUS_SUCCESS = "1";

export function BoxActionProvider({
  onRefresh,
  requestUpdateClient,
}: BoxActionProvider) {
  const { addToast } = useToasts();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik<FormDataProps>({
    initialValues: {
      status: "",
      reason: "",
    },

    validationSchema: Yup.object({
      status: Yup.string().required("É obrigatório"),
      reason: Yup.string().required("É obrigatório"),
    }),

    onSubmit: handleSubmit,
  });

  async function handleSubmit(data: FormDataProps) {
    setIsLoading(true);
    try {
      if (data.status === "1")
        await api.patch(
          `/request-update-client/approve/${requestUpdateClient.id}`,
          { observation: data.reason }
        );

      if (data.status === "0")
        await api.patch(
          `/request-update-client/refuse/${requestUpdateClient.id}`,
          { observation: data.reason }
        );

      queryClient.invalidateQueries("RequestUpdateClients");
      queryClient.invalidateQueries([
        "RequestUpdateClient",
        requestUpdateClient?.id,
      ]);

      addToast("Atualização cadastral alterado com sucesso", {
        appearance: "success",
        autoDismiss: true,
      });

      onRefresh();
    } catch (error) {
      return addToast(
        "Desculpe, ocorreu um erro interno, Tente novamente mais tarde",
        {
          appearance: "error",
          autoDismiss: true,
        }
      );
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Box style={{ marginBottom: "20px" }}>
      <BoxHeading>Aprovação do cliente</BoxHeading>

      <LayoutForm
        onSubmit={formik.handleSubmit}
        stylesContainerForm={{ padding: "0" }}
      >
        <ButtonCheck
          bgColor="#11111d"
          name="status"
          value={formik.values.status}
          setValue={(data) => {
            formik.setFieldValue("status", data);
          }}
          options={[
            {
              value: STATUS_SUCCESS,
              field: "Aprovar",
              color: "rgba(0, 153, 76, 0.8)",
            },
            {
              value: STATUS_CANCEL,
              field: "Reprovar",
              color: "rgba(200, 0, 0, 0.7)",
            },
          ]}
          error={
            formik.touched.status && formik.errors.status
              ? formik.errors.status
              : undefined
          }
        />

        <Textarea
          label="Observação"
          error={
            formik.touched.reason && formik.errors.reason
              ? formik.errors.reason
              : undefined
          }
          {...formik.getFieldProps("reason")}
        />

        <Button isLoading={isLoading}>Enviar</Button>
      </LayoutForm>
    </Box>
  );
}
